'use client';
import "./globals.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'hover.css/css/hover.css'; 
import { useEffect, useState } from 'react';
import Loader from './components/Loader';


export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // simulate loading delay or wait for full content load
    const handleComplete = () => setLoading(false);

    if (document.readyState === 'complete') {
      handleComplete();
    } else {
      window.addEventListener('load', handleComplete);
    }

    return () => {
      window.removeEventListener('load', handleComplete);
    };
  }, []);

  useEffect(() => {
    // ✅ Voiceflow chat widget
    const vfScript = document.createElement('script');
    vfScript.src = 'https://cdn.voiceflow.com/widget/bundle.mjs';
    vfScript.type = 'text/javascript';
    vfScript.async = true;
    vfScript.onload = () => {
      if (window.voiceflow?.chat) {
        window.voiceflow.chat.load({
          verify: { projectID: '66ba85a2cf5adb4c27b4fc0e' },
          url: 'https://general-runtime.voiceflow.com',
          versionID: 'production',
        });
      }
    };
    document.body.appendChild(vfScript);

    // ✅ Google Analytics gtag.js
    const gaScript = document.createElement('script');
    gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-RJLHRFWD5T';
    gaScript.async = true;
    document.head.appendChild(gaScript);

    const inlineGAScript = document.createElement('script');
    inlineGAScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){ dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', 'G-RJLHRFWD5T');
    `;
    document.head.appendChild(inlineGAScript);
  }, []);

  return (
    <html lang="en">
      <body>
        {loading && <Loader />}
        {!loading && children}
      </body>
    </html>
  );
}